module.exports = __webpack_public_path__ + "media/images/company-2fb9361597b291680574caa0cab215dd.png";